module.exports = __webpack_public_path__ + "img/bronze-medal.402b1746.gif";